export default "__VITE_ASSET__Cp_HY7J___"